import { FunctionComponent, type JSX } from 'react';

import { Modal } from '@payaca/ambrosia';
import SelectCustomerControl from '../selectCustomerControl/SelectCustomerControl';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSelectCustomer: (customerId: number) => void;
};
const SelectCustomerModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  onSelectCustomer,
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      title="Select a customer"
      onClose={onClose}
      size="md"
    >
      <Modal.Body>
        <SelectCustomerControl onSelectCustomer={onSelectCustomer} />
      </Modal.Body>
    </Modal>
  );
};

export default SelectCustomerModal;
